import { useLazyQuery } from '@apollo/client';
import { QueryResult } from './types';
import { bankInstitutionsQuery } from './gql';

export const useBankInstitutionsGql = () => {
  const [runBankInstitutionsGql, { loading, data, error }] = useLazyQuery<QueryResult>(bankInstitutionsQuery, {
    context: {
      headers: {
        userFunctionKey: '9f61408e3afb633e50cdf1b20de6f466'
      }
    },
    fetchPolicy: 'network-only'
  });

  return {
    runBankInstitutionsGql,
    loadingBankInstitutions: loading,
    dataBankInstitutions: data?.getBankInstitutions || [],
    errorBankInstitutions: error
  };
};
